<template>
    <div class="row bg-wave py-4">

        <div class="w-layout-1020-limit mx-auto">

            <h5 class="text-title-color my-4">{{ $t('contract-title') }}</h5>

            <div class="accordion mx-auto my-4" id="accordion">

                <div class="container">
                    <main>
                        <h3 class="contract_title">國內固定航線載客船舶乘客運送定型化契約</h3>
                        <p class="publication_date">交通部105年4月19日交航(一)字第1059800070號公告修正發布</p>
                        <section class="section">
                            <h4 class="contract_sub_title">審閱期間：本契約審閱期間為7日(不得少於1日)。</h4>
                            <h4 class="contract_sub_title">
                                藍白航運股份有限公司（以下簡稱運送人）與船票上所列載之乘客同意遵守下列條款：
                            </h4>
                            <h4>第一條：（本契約適用對象及效力）</h4>
                            <br>
                            <p>本契約適用對象為經營國內固定航線航程之載客船舶運送人與乘客。</p>
                            <p>運送人與乘客間有更利於乘客之特殊約定者，依其約定。未約定者，仍依本契約辦理。</p>
                            <h4>第二條：（船票應記載事項）</h4>
                            <br>
                            <p>
                                船票應載明船舶所有人或運送人、船名、發航港名、目的港名、中途停靠點、等級、艙位號數、票價、票號、發航日期、預定發航時間（段）、合理運送時間及發售日期等事項，並視為運送契約之一部分。經航政機關指定之固定航線，並應記載乘客之姓名。
                            </p>
                            <p>
                                運送人如允許乘客持用電子票證搭船者，應將前項船票應記載事項之相關資訊於網站、售票處、搭船處等明顯處所揭露之。
                            </p>
                            <h4>第三條：(退票還款手續)</h4>
                            <br>
                            <p>
                                船票僅限票載當日當航次有效。乘客得於該航班表定開航時間發航前支付票面價額之百分之10退票手續費，向運送人或原售票業者憑票要求辦理退票還款手續。但乘客於發航前因死亡、疾病或其他不可歸責之事由而退票者，免收手續費。
                            </p>
                            <p>
                                表定航班變更或取消時，乘客得於原預定發航日起30日內要求辦理退票，運送人或原售票業者應全額退費並不得收取任何手續費；或得於原預定發航日30日內選擇更改搭乘航班。
                            </p>
                            <h4>第四條：（運送之變更或停航）</h4>
                            <br>
                            <p>
                                運送人應依船票所載或公告之發航日期、時間與航線，自發航港運送乘客至目的港，非有正當理由，不得任意變更。如有變更、增減班或停航時，應以顯著方式即時公告及利用有效方式通知乘客。
                            </p>
                            <p>
                                運送人違反前項規定時，乘客得解除契約，辦理退票，且運送人不得收取手續費。如有損害，並得請求賠償。
                            </p>
                            <p>
                                乘客因運送人超過合理運送時間之運送遲到而致損害者，運送人應負賠償責任。但運送人能證明其遲到係因天候變化、屬非可歸責於運送人之機件故障、航政機關命令約束或其他必要情況者，除另有交易習慣者外，其賠償責任以乘客因遲到而增加支出之必要費用為限。
                            </p>
                            <h4>第五條：（運送變更於運送人之處理）</h4>
                            <br>
                            <p>
                                運送人於確定船舶無法依表定時間啟程、靠泊，致遲延三十分鐘以上，或變更航線、靠泊地點時，應即向乘客詳實說明原因及處理方式，並應視實際情形及斟酌乘客需要，適時提供下列協助：
                            </p>
                            <ul>
                                <li>(一)必要之通訊。</li>
                                <li>(二)必要之飲食或膳宿。</li>
                                <li>(三)必要之禦寒或醫藥急救之物品。</li>
                                <li>(四)必要之轉運或其他交通工具。</li>
                            </ul>
                            <p>
                                運送人應合理照顧乘客權益，如受限於當地實際情況，無法提供前項協助時，應即時向乘客詳實說明原因，並妥善處理。
                            </p>
                            <p>
                                因可歸責於運送人事由之突發性停航，除即時發布公告周知外，並應立即協調安排乘客改搭其他船舶或交通工具。如致乘客無法扺達目的地或接續其他交通工具時，運送人應提供必要之飲水、安排膳食住宿。
                            </p>
                            <h4>第六條：（乘客因運送而受傷之責任）</h4>
                            <br>
                            <p>運送人對於乘客因運送所受之傷害應負賠償責任。但因乘客之過失或係不可抗力所致者，不在此限。</p>
                            <h4>第七條：（船艙無空調之退費處理）</h4>
                            <br>
                            <p>
                                運送人營運之船舶於航程中應視室內、外溫差，適時調節船艙室溫，裝有冷氣船舶如未於航程中開啟空調或空調發生故障，其最低賠償金額為票面價額之百分之20。
                            </p>
                            <h4>第八條：（優待票使用對象）</h4>
                            <br>
                            <p>乘客有下列情形之一，應享有票價優待：</p>
                            <ul>
                                <li>(一)未滿三歲之兒童，由其監護人陪同，該兒童享有免費優待。</li>
                                <li>(二)未滿十二歲之兒童享有半價優待。</li>
                                <li>(三)年滿六十五歲以上享有半價優待。</li>
                                <li>
                                    (四)身心障礙者執身心障礙手冊或證明，應予半價優待；執身心障礙手冊或證明經需求評估結果認需有人陪伴者，其必要陪伴者以一人為限，得享有半價優待。
                                </li>
                                <li>(五)其他：＿＿＿＿。</li>
                            </ul>
                            <p>前項優待應於購票及搭船時，提供身分證明文件，並僅得擇一，不得享有二重（含）以上優待。</p>
                            <h4>第九條：（乘客隨身攜帶及託運行李之限制）</h4>
                            <br>
                            <p>
                                乘客隨身攜帶行李以不超過2件為原則，合計不超過20公斤，每件長寬高不得超過80公分，超過上述限制者，應改以託運方式運送，運送人未提供行李託運服務時，得拒絕託交運送。
                            </p>
                            <p>
                                託運行李包裝不完整於運送過程中有損壞之虞者，運送人得要求包裝完整，乘客如不願配合，運送人得拒絕載運該行李。
                            </p>
                            <p>
                                乘客攜帶動物登船，應置於寵物箱、小籠或小容器內，且包裝完固、無糞便、液體漏出之虞，動物之頭、尾及四肢均不得露出，每位乘客以攜帶一件為限，尺寸不得超過長五十五公分、寬四十五公分、高四十五公分。但執行任務之警犬、導盲犬、導聾犬、肢體輔助犬或專業訓練人員陪同之導盲幼犬、導聾幼犬、肢體輔助幼犬，不在此限。
                            </p>
                            <p>前三項內容，運送人應於網站、售票處、搭船處等明顯處所揭露之。</p>
                            <h4>第十條：（託運行李之損害賠償事宜）</h4>
                            <br>
                            <p>
                                乘客託運行李之損害，運送人應負賠償之責。但因可歸責於乘客之故意或過失事由所致者，得減輕或免除之。
                            </p>
                            <p>
                                運送人對乘客行李應負之損害賠償金額，應依其應交付時目的地之價值計算。但乘客證明其受有更大損害者，得就該損害請求賠償。
                            </p>
                            <p>
                                乘客行李損害之賠償額，有特別書面契約，且更有利於乘客者，依其契約；無特別契約者，依前項之賠償標準。
                            </p>
                            <p>
                                乘客如於託運行李中放入錢幣、珠寶、銀器、可轉讓之有價證券、公債、貴重物品、樣品或商業文件等物品者，應報值，其報值格式如附件－貴重物品託運報值單；未經報值之物品如於運送途中遺失或毀損，運送人僅依第二項規定負賠償責任。但運送人有故意、重大過失，或接受乘客以報值行李方式辦理託運者，不在此限。
                            </p>
                            <p>
                                運送途中如託運行李中之易碎、易腐等物品所致行李之全部或部分毀損，運送人應負賠償責任。但運送人能證明其毀損，係因不可抗力、運送物之性質或乘客之過失所致者，不在此限。
                            </p>
                            <h4>第十一條：（載運物品之限制）</h4>
                            <br>
                            <p>
                                為維護航行安全及乘客安寧，乘客不得攜帶或放置武器及危險物品於行李中，亦不得攜帶不適宜隨船運送之動物，違者運送人得拒絕其登船。但負有特殊任務必須攜帶武器之人員不在此限，並應依規定由所屬機關出具證明文件，由攜帶人自動請求查驗。
                            </p>
                            <h4>第十二條：（拒載條款）</h4>
                            <br>
                            <p>
                                運送人應採取適當措施，確保乘客無障礙搭乘客船。但縱採取適當措施，特定乘客仍有危害健康或航行安全之虞者，運送人得依相關法規規定限制其搭乘。
                            </p>
                            <h4>第十三條：（運送人保險投保責任）</h4>
                            <br>
                            <p>
                                運送人應為乘客投保傷害保險，每一乘客保險金額為新臺幣250萬元（不得少於相關法規所訂金額）。
                            </p>
                            <h4>第十四條：（資訊及申訴管道之揭示）</h4>
                            <br>
                            <p>運送人應於明顯處所揭示下列資訊，並提供完整、透明化及有效之申訴管道：</p>
                            <ul>
                                <li>(一)合理運送時間：30分鐘</li>
                                <li>(二)運送人公司名稱：藍白航運股份有限公司</li>
                                <li>(三)運送人公司負責人：李明信</li>
                                <li>(四)客服（申訴）專線：08-8334866</li>
                                <li>(五)運送人公司網址：https://www.leucosapphire.com/</li>
                                <li>(六)電子郵件地址：server@ leucosapphire.com</li>
                                <li>(七)運送人公司地址：屏東縣東港鎮朝安里朝隆路43號</li>
                                <li>(八)主管機關名稱及電話（含申訴電話）：交通部航港局南部航務中心:07-2620563</li>
                                <li>屏東縣政府交通旅遊處: 08-7320415</li>
                            </ul>
                            <h4>第十五條：（爭議之處理）</h4>
                            <br>
                            <p>
                                運送人與乘客雙方發生運送糾紛時，運送人應即主動與乘客協調處理，且乘客不得藉故遲延下船。
                            </p>
                            <h4>第十六條：（未盡事宜之處理）</h4>
                            <br>
                            <p>
                                本契約如有未盡事宜，依相關法令、習慣及平等互惠與誠實信用原則公平解決之。
                            </p>
                            <h4>第十七條：（爭訟之管轄法院）</h4>
                            <br>
                            <p>
                                因本契約涉訟時，雙方同意以屏東地方法院為第一審管轄法院。但不得排除消費者保護第四十七條或民事訴訟法第四百三十六條之九規定之小額訴訟管轄法院之適用。
                            </p>
                        </section>
                        <!-- <section>
                            <h3>附件</h3>
                                <h3><a href="">下載貴重物品</a></h3>
                        </section> -->
                        <!-- 继续添加其他部分的内容 -->
                    </main>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    watch: {

    },
    methods: {
    },
    mounted() {
    }
}
</script>
<i18n src="./locale/locale.json"></i18n>
<style scope>
@import './style/contract.css';
</style>
